// oauthConfigService.js
import { axiosInstance } from "@/api/axiosInstance";

export const oauthConfigService = {
    getConfig: async () => {
        const response = await axiosInstance.get(`/admin/oauth-config`);
        return response.data;
    },
    updateConfig: async (configDto) => {
        const response = await axiosInstance.patch(`/admin/oauth-config`, configDto);
        return response.data;
    },
    getPublicConfig: async () => {
        const response = await axiosInstance.get(`/public/oauth-configs`);
        return response.data;
    },
    googleSignIn: async () => {
        const response = await axiosInstance.get(`/auth/social/google`);
        return response.data;
    },
    facebookSignIn: async () => {
        const response = await axiosInstance.get(`/auth/social/facebook`);
        return response.data;
    },
};